<template>
    <div class="footer-div">
    <div class="terms-div" @click="toggleCheckbox">
        <PrimeCheckbox 
            v-model="checked" 
            binary 
            class="pt-0.5" 
            :tabindex="0"
            @keydown.enter="checked = !checked"
            @keydown.space.prevent="checked = !checked"
            aria-label="I agree to the Terms of Service and Privacy Policy"
            @click.stop 
        />
        <p>
            I agree to the
            <a href="https://privacybee.com/terms-of-service/" target="_blank">Terms of Service</a> &
            <a href="https://privacybee.com/privacy-policy/" target="_blank">Privacy Policy</a>
        </p>
    </div>
        <div class="w-full">
            <PrimeButton label="Purchase" class="w-full" :disabled="!isFormValid" :loading="isLoading" @click="handlePurchase" />
        </div>
    </div>
</template>
<script setup lang="ts">
import PrimeButton from 'primevue/button';

const emit = defineEmits(['purchase', 'update:isChecked']);

const props = defineProps({
    isFormValid: Boolean,
    isLoading: Boolean,
});

const checked = ref(false);

const toggleCheckbox = (e: MouseEvent) => {
    if ((e.target as HTMLElement).tagName === 'A') return;
    checked.value = !checked.value;
};

const handlePurchase = () => {
    emit('purchase');
};

watch(checked, () => {
    emit('update:isChecked', checked.value);
});
</script>
<style lang="scss" scoped>
.footer-div {
    @apply flex flex-col pt-6 items-center gap-2.5 self-stretch;
}
.terms-div {
    @apply flex pb-2 justify-center items-start gap-2 cursor-pointer;

    p {
        @apply text-[var(--ink-muted)] text-[14px] font-normal leading-[20px];
    }

    a {
        @apply text-[var(--action)] underline;
    }
}
</style>
